import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function DescargaPdf({ ruta, params, etiqueta, testid, className = "", mensaje = "Informe PDF generado" }) {
  const [cargando, setCargando] = useState(false);
  const bajar = async () => {
    setCargando(true);
    try {
      const r = await api.get(ruta, { params, responseType: "blob", timeout: 240000 });
      const nombre = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "TierraScore_informe.pdf";
      const url = URL.createObjectURL(new Blob([r.data], { type: r.headers["content-type"] || "application/pdf" }));
      const a = document.createElement("a"); a.href = url; a.download = nombre; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      toast.success(mensaje);
    } catch { toast.error("No se pudo descargar el archivo, reintentá"); }
    finally { setCargando(false); }
  };
  return <button onClick={bajar} disabled={cargando} className={`inline-flex items-center justify-center gap-2 rounded-full border border-[#1f5f3f] text-[#1f5f3f] px-4 py-2 text-sm font-semibold hover:bg-emerald-50 disabled:opacity-50 ${className}`} data-testid={testid}>
    {cargando ? <><Loader2 className="w-4 h-4 animate-spin" />Generando informe…</> : <><FileDown className="w-4 h-4" />{etiqueta}</>}</button>;
}

export function InformePdf({ cod, padron }) {
  return <DescargaPdf ruta="/portal/titulares/parcela/informe.pdf" params={{ cod, padron }} etiqueta="Descargar informe PDF" testid="parcela-informe-pdf" className="w-full !bg-[#1f7a4d] !text-white !border-[#1f7a4d] hover:!bg-[#124a2f]" />;
}
